"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardReducer = void 0;
const BoardState_1 = require("./BoardState");
const BoardStateAction_1 = require("./BoardStateAction");
const reducePreDeal = (action, state) => {
    if (BoardStateAction_1.BoardActions.isDealCards(action)) {
        return BoardState_1.BoardStates.Deal;
    }
    else if (BoardStateAction_1.BoardActions.isEvalShowdown(action)) {
        return BoardState_1.BoardStates.Showdown;
    }
    return state;
};
const reduceDeal = (action, state) => {
    if (BoardStateAction_1.BoardActions.isDealFlop(action)) {
        return BoardState_1.BoardStates.Flop;
    }
    else if (BoardStateAction_1.BoardActions.isEvalShowdown(action)) {
        return BoardState_1.BoardStates.Showdown;
    }
    return state;
};
const reduceFlop = (action, state) => {
    if (BoardStateAction_1.BoardActions.isDealTurn(action)) {
        return BoardState_1.BoardStates.Turn;
    }
    else if (BoardStateAction_1.BoardActions.isEvalShowdown(action)) {
        return BoardState_1.BoardStates.Showdown;
    }
    return state;
};
const reduceTurn = (action, state) => {
    if (BoardStateAction_1.BoardActions.isDealRiver(action)) {
        return BoardState_1.BoardStates.River;
    }
    else if (BoardStateAction_1.BoardActions.isEvalShowdown(action)) {
        return BoardState_1.BoardStates.Showdown;
    }
    return state;
};
const reduceRiver = (action, state) => {
    if (BoardStateAction_1.BoardActions.isEvalShowdown(action)) {
        return BoardState_1.BoardStates.Showdown;
    }
    return state;
};
const reduceShowdown = (action, state) => {
    if (BoardStateAction_1.BoardActions.isResetBoard(action)) {
        return BoardState_1.BoardStates.PreDeal;
    }
    return state;
};
const BoardReducer = (action, state) => {
    if (BoardState_1.BoardStates.isPreDeal(state)) {
        return reducePreDeal(action, state);
    }
    else if (BoardState_1.BoardStates.isDeal(state)) {
        return reduceDeal(action, state);
    }
    else if (BoardState_1.BoardStates.isFlop(state)) {
        return reduceFlop(action, state);
    }
    else if (BoardState_1.BoardStates.isTurn(state)) {
        return reduceTurn(action, state);
    }
    else if (BoardState_1.BoardStates.isRiver(state)) {
        return reduceRiver(action, state);
    }
    else if (BoardState_1.BoardStates.isShowdown(state)) {
        return reduceShowdown(action, state);
    }
    return state;
};
exports.BoardReducer = BoardReducer;
//# sourceMappingURL=BoardStateReducer.js.map